//=require DW.TimelineItem.js
// Keeps track of SVG Elements, animates them, resets them, etc ...


// Extend ScrollAnimation Item
DW.SVGAnimationElement = function(container) {
	this.container = container;
	this.svg = this.container.querySelector('svg');
	this.snap = Snap(this.svg);
	this.pathToAnimate = this.snap.select('.start-path');
	this.startPath = this.container.querySelector('.start-path').getAttribute('d');
	this.endPath = this.container.querySelector('.end-path').getAttribute('d');
	this.animating = false; // Keeps track, if animation is active
	this.animated = false; // Keeps track if element was already animated
};

extendObj(DW.SVGAnimationElement, DW.ScrollAnimationItem);

DW.SVGAnimationElement.prototype.animateWhileInView = function() {
	if(!this.animating && !this.animated) {
		this.animating = true;
		this.pathToAnimate.animate({
			d: this.endPath
		}, 500, mina.easeinout, function() {
			this.animating = false;
			this.animated = true;
		}.bind(this));
	}
};


DW.SVGAnimationElement.prototype.resetAnimation = function() {
	if(this.animated) {
		this.pathToAnimate.node.setAttribute('d', this.startPath);
		this.animated = false;
	}
};
